import { app } from '@config';
const Engine = () => {
  return <p className='text-foreground/60'>
      Celestia Network {app.Dependencies.Celestia} <br />
      <br />
      Copyright&#169;TheIceJI.com <br />
      <span className='text-primary text-xs'>All rights reserved</span>
      <br />
      {/* <Link
       href='https://constella.theiceji.com/changelog'
       className='text-2xs cursor-pointer font-light opacity-60 hover:opacity-100 md:text-base'
       onClick={() => _onClearModal()}
       >
       changelog
       </Link>
       {' | '} */}
      <a className='cursor-pointer font-light text-2xs text-foreground/60 hover:text-foreground/100 md:text-base' href='https://cosmos.theiceji.com'
    // onClick={() => _onClearModal()}
    rel='noopener noreferrer' target='_blank'>
        cosmos
      </a>
    </p>;
};
export { Engine };